<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'configuracion'}">{{$t("configuracion")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'clientes',query: { filtro: filtro }, params:{idCompany: idCompany}}">
                                {{$t("clientes")}}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{action}} {{$t("cliente")}}</li>
                    </ol>
                </nav>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-12">
                            <h2 class="tituloNumier"><i class="fa fa-building"></i> {{nombreEmpresa}}</h2>
                            <hr>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="nameCliente"><strong>{{$t("nombreCliente")}} <span style="color: red">*</span></strong></label>
                                <input type="text" class="form-control"
                                       :class="{'is-valid': cliente.name.length >0 && cliente.name.length <= maxNameCliente,
                                       'is-invalid': cliente.name.length > maxNameCliente}"
                                       id="nameCliente" v-bind:placeholder="$t('introduzcaNombre')"
                                       v-model="cliente.name" ref="name">
                                <input type="hidden" v-model="cliente.xname">
                                <small class="form-text text-muted">{{cliente.name.length}}/50</small>
                            </div>
                        </div>

                       <!--<div class="col-md-4">
                            <div class="form-group">
                                <label><strong>Categoria cliente</strong></label>
                                <el-select class="select-default"
                                           size="large"
                                           v-model="cliente.idCategory"
                                           filterable
                                           placeholder="Selecciona categoria cliente...">
                                    <el-option v-for="category in listCategoriasClientes"
                                               class="select-primary"
                                               :value="category.id"
                                               :label="category.name"
                                               :key="category.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>-->

                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="codigoBarras"><strong>{{$t("codigoDeBarra")}} <span style="color: red">*</span></strong></label>
                                <input :disabled="idCliente" type="text" class="form-control"
                                       id="codigoBarras" v-bind:placeholder="$t('introduzcaCodigoDeBarras')"
                                       v-model="cliente.barCode">
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="cifnif"><strong>{{$t("cifNif")}}</strong></label>
                                <input :disabled="idCliente" type="text" class="form-control"
                                       id="cifnif" v-bind:placeholder="$t('introduzcaCodigoDeBarras')"
                                       v-model="cliente.cifnif">
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="apellido"><strong>{{$t("apellido")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="apellido" v-bind:placeholder="$t('introduzcaApellido')"
                                       v-model="cliente.surName">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="direccion"><strong>{{$t("direccion")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="direccion" v-bind:placeholder="$t('introduzcaDireccion')"
                                       v-model="cliente.address">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="cp"><strong>{{$t("codigoPostal")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="cp" v-bind:placeholder="$t('introduzcaCodigoPostal')" v-model="cliente.cp">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="ciudad"><strong>{{$t("ciudad")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="ciudad" v-bind:placeholder="$t('introduzcaCiudad')" v-model="cliente.city">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="provincia"><strong>{{$t("provincia")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="provincia" v-bind:placeholder="$t('introduzcaProvincia')"
                                       v-model="cliente.province">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="email"><strong>{{$t("email")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="email" v-bind:placeholder="$t('introduzcaEmail')" v-model="cliente.email">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="phone"><strong>{{$t("telefono")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="phone" v-bind:placeholder="$t('introduzcaTelefono')" v-model="cliente.phone">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label><strong>{{$t("fechaDeCumpleanyos")}}</strong></label>
                                <el-date-picker v-model="cliente.date"
                                                type="date"
                                                :picker-options="dateRangeOptions1"
                                                :placeholder="$t('fechaDesde')"
                                                format="MM-dd-yyyy">
                                </el-date-picker>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="saldo"><strong>{{$t("saldo")}}</strong> <span style="font-size: smaller">({{$t("infoCliente")}})</span></label>

                                <vue-numeric currency="€"
                                             id="saldo"
                                             inputmode="decimal"
                                             type="text"
                                             class="form-control"
                                             currency-symbol-position="suffix"
                                             :precision="2"
                                             :minus="true"
                                             v-model=cliente.saldo
                                             @keydown.native="$methods.evitarComasDecimales"
                                             ></vue-numeric>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label><strong>{{$t("tarifa")}}</strong>
                                </label>
                                <el-select class="select-default"
                                           size="large"
                                           v-model="cliente.tarifa"
                                           filterable
                                           :placeholder="$t('seleccionaCompania')">
                                    <el-option v-for="t in listaTarifa"
                                               class="select-primary"
                                               :value="t.value"
                                               :label="t.nombre"
                                               :key="t.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="descuento"><strong>{{$t("descuento")}}</strong><span
                                        style="font-size: smaller">(0% - 100%)</span></label>
                                <input type="number" class="form-control"
                                       id="descuento" v-bind:placeholder="$t('introduzcaTelefono')"
                                       v-model="cliente.descuento">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="descuentoImporte"><strong>{{$t("descuentoImporte")}}</strong> </label>
                                <input type="number" class="form-control"
                                       id="descuentoImporte" v-bind:placeholder="$t('introduzcaTelefono')"
                                       v-model="cliente.descuentoImporte">
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label><strong>{{$t("notas")}}</strong></label>
                                <textarea v-model="cliente.notas" class="form-control">
                            </textarea>
                            </div>
                        </div>
                        <template v-if="tieneDimoni">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="cuentaSocio"><strong>{{$t("cuentaContableSocio")}}</strong></label>
                                    <input type="text" class="form-control"
                                        id="cuentaSocio" v-bind:placeholder="'43000000'" v-model="cliente.cuentaSocio">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="cuentaLevy"><strong>{{$t("cuentaContableLevy")}}</strong></label>
                                    <input type="text" class="form-control"
                                        id="cuentaLevy" v-bind:placeholder="'44000000'" v-model="cliente.cuentaLevy">
                                </div>
                            </div>
                        </template>
                        <div class="col-md-12">
                            <div class="form-group">

                                <div class="form-group">
                                    <label>
                                        <strong>{{$t("recargoEquivalencia")}}</strong>
                                    </label>
                                    <el-switch v-model="cliente.recargo"
                                               active-color="#13ce66"
                                               inactive-color="#bcbcbc">
                                    </el-switch>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">

                                <div class="form-group">
                                    <label>
                                        <strong>{{$t("baja")}}</strong>
                                    </label>
                                    <el-switch v-model="cliente.baja"
                                               active-color="#13ce66"
                                               inactive-color="#bcbcbc">
                                    </el-switch>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            
                            <button  class="btn btn-primary" @click="saveCliente()" :disabled="inProgress"><i
                                    class="fa fa-check-square"></i> {{$t("guardar")}}
                            </button>

                            <button @click="cancelarRuta()" class="btn btn-danger"><i class="fa fa-window-close"></i>
                                {{$t("cancelar")}}
                            </button>


                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import swal from 'sweetalert2';
    import {Loading} from 'element-ui';
    import {
        DatePicker,
        Select,
        Option,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Button,
        Checkbox,
        Switch
    } from 'element-ui'


    export default {
        props: ['idBusiness', 'idCliente', 'pag', 'idCompany','filtro'],
        created() {
            this.action = this.idCliente ? this.$i18n.t("editar") : this.$i18n.t("nuevo");
            this.loadingGeneral = Loading.service({text: this.$t('cargando')});

            this.identificacionEmpresa();
            this.getConfigDimoni();
            if (this.idCliente) {
                this.getCliente();
            }
            else{
                this.loadingGeneral.close();
                //this.getCategoryClientes();
            }
        },
        components: {
            [Checkbox.name]: Checkbox,
            [Switch.name]: Switch,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        mounted() {
            this.$refs.name.focus();
        },
        data() {
            return {
                loadingGeneral: null,
                cliente: {
                    idCategory:'0',
                    date: "",
                    tarifa: 0,
                    barCode: "",
                    cifnif: "",
                    name: "",
                    xname: "",
                    surName: "",
                    address: "",
                    cp: "",
                    city: "",
                    province: "",
                    email: "",
                    phone: "",
                    saldo: 0.00,
                    descuento: 0.00,
                    descuentoImporte: 0.00,
                    baja: false,
                    notas:"",
                    cuentaSocio:"",
                    cuentaLevy:"",
                    recargo:false,
                },
                listaTarifa: [{nombre: this.$t('noSeleccionada'), value: 0}, {
                    nombre: this.$t('tarifa1'),
                    value: 1
                }, {nombre: this.$t('tarifa2'), value: 2}, {nombre: this.$t('tarifa3'), value: 3}, {nombre: this.$t('tarifa4'), value: 4}],

                dateRangeOptions1: {
                    firstDayOfWeek: 1
                },

                tieneDimoni:false,
                checkSelectAll: false,
                listBusinesses: [],
                checkReply: false,
                maxNameCliente: 50,
                action: "",
                inProgress: false,
                nombreEmpresa: "",
                listCategoriasClientes:[],
            }
        },
        methods: {
            identificacionEmpresa() {

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                        idCompany: this.idCompany
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'general/identifyCompany', config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.nombreEmpresa = response.data.result

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },
            checkCampos() {
                if (this.cliente.name.length > this.maxNameCliente) {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('laLongitudDelNombreNoPuedeSerMayorDe') + this.maxNameCliente + '.',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return false;
                } else if (this.cliente.name === null || this.cliente.name.length === 0 && (this.cliente.cifnif === "" || this.cliente.barCode === "")) {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return false;
                }
                else if(this.cliente.cifnif === "" && this.cliente.barCode === ""){

                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return false;
                }
                else if (this.cliente.descuentoImporte < 0 || this.cliente.descuentoImporte > 100) {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return false;
                }
                else {
                    return true;
                }
            },
            getCliente() {
                var config = {
                    params: {
                        idCategory: this.idCategory,
                        idCliente: this.idCliente,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'clients/getClientById', config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.cliente = response.data.result;

                            //vm.getCategoryClientes();

                            vm.loadingGeneral.close();

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.result,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },
            getCategoryClientes() {

                const controller = 'getCategoriesClientsByCompany';
                var config = {
                    params: {
                        pag: 0,
                        idCompany: this.idCompany,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "clients/" + controller, config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.listCategoriasClientes = response.data.result.categoryClients;

                            let category = {
                                name: vm.$t('sinCategoria'),
                                id: '0'
                            };

                            vm.listCategoriasClientes.unshift(category)
                        }
                        else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                            vm.respuesta = false;
                        }

//                        vm.loading.close();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            //hace visible los campos socio y levy si el cliente tiene la configuración sage
            getConfigDimoni() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.axios
                    .get(
                        this.$store.getters.apiUrl + "clients/tieneDimoni",
                        config
                    ).then(function(response) {
                        if (response.data.result) {
                            vm.tieneDimoni=true;       
                        } else {
                            vm.tieneDimoni=false;   
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            },

            cancelarRuta() {
                this.$router.push({name: 'clientes',query: { filtro: this.filtro }, params: {idBusiness: this.idBusiness, 'pag': this.pag,'idCompany': this.idCompany}})
            },

            saveCliente() {
                if (this.checkCampos()) {
                    this.inProgress = true;

                    var config = {
                        params: {
                            jwt: this.$store.getters.jwt
                        },
                        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                    };
                    var params = {
                        idCompany: this.idCompany,
                        cliente: this.cliente,
                        jwt: this.$store.getters.jwt
                    };

                    let vm = this;
                    let controller = this.idCliente ? "editClientById" : "newClientByCompany";
                    this.axios.post(this.$store.getters.apiUrl + 'clients/' + controller, params, config)
                        .then(function (response) {
                            vm.inProgress = false;

                            if (response.data.response) {
                                let notify = vm.idCliente ? vm.$t('actualizado') : vm.$t('creado');
                                vm.$notify({
                                    message: vm.$t('cliente') + ' ' + notify + ' ' + vm.$t('correctamente'),
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });

                                // console.log("Response Data:", response.data.result);

                                // Log del saldo
                                if (!vm.idCliente) {
                                    // Nuevo cliente: Log inicial del saldo
                                    let logParams = {
                                        idCompany: vm.idCompany,
                                        clientName: vm.cliente.name,
                                        saldo: parseFloat(vm.cliente.saldo),
                                        jwt: vm.$store.getters.jwt
                                    };
                                    vm.axios.post(vm.$store.getters.apiUrl + 'clients/setInitialSaldo', logParams, config)
                                        .then(function (logResponse) {
                                            if (!logResponse.data.response) {
                                                console.error("Error logging initial saldo:", logResponse.data.message);
                                            }
                                        }).catch(function (error) {
                                            console.error("Error logging initial saldo:", error);
                                        });
                                } else {
                                    // Editar cliente: Actualizar saldo en logs
                                    let modifyParams = {
                                        idCompany: vm.idCompany,
                                        idCliente: vm.idCliente,
                                        clientName: vm.cliente.name,
                                        saldo: parseFloat(vm.cliente.saldo),
                                        jwt: vm.$store.getters.jwt
                                    };
                                    vm.axios.post(vm.$store.getters.apiUrl + 'clients/modifySaldoLog', modifyParams, config)
                                        .then(function (updateResponse) {
                                            if (!updateResponse.data.response) {
                                                console.error("Error updating saldo log:", updateResponse.data.message);
                                            }
                                        }).catch(function (error) {
                                            console.error("Error updating saldo log:", error);
                                        });
                                }

                                vm.$router.push({
                                    name: 'clientes',
                                    params: { idBusiness: vm.idBusiness, 'pag': vm.pag, 'idCompany': vm.idCompany }
                                });

                            } else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        }).catch(function (error) {
                            console.log(error);
                            vm.inProgress = false;
                        });
                }
            },
        }

    }
</script>

<style scoped>
    .card {
        padding: 20px;
    }

</style>




// WEBPACK FOOTER //
// src/pages/Widgets/Clientes/ClienteForm.vue